<template>
  <div class="animated fadeIn">
    <b-tabs v-model="tabIndex">
      <b-tab :title="'Pesquisar'">
          <template slot="title">
            <div @click="onResetBoard"><i class="fa fa-search text-third"></i><span class="d-md-down-none pl-1 text-third"> {{$lang.EmployeeBoard.Search.TitleTab}}</span></div>
          </template>
          <Search ref="Search"
                  v-on:Edit="onEditEmployeeBoard"
                  v-on:New="onNewBoard"
                  v-on:Delete="onDeleteBoard" />
        </b-tab>
      <b-tab :title="'Quadro'">
        <template slot="title">
          <i class="fas fa-user-friends text-third"></i><span class="d-md-down-none pl-1 text-third"> {{$lang.EmployeeBoard.Board.TitleTab}}</span>
        </template>
        <Board ref="Board" v-on:Delete="onDeleteBoard" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import Search from './search/search.vue'
import Board from './board/board.vue'
import EmployeeBoardRepository from '@/shared/http/repositories/business/employeeboard'
import { toast } from '@/shared/utils/UIHelper'

const Tabs = {
  SEARCH: 0,
  BOARD_EMPLOYEE: 1
}

export default {
  name: 'employeeboard',
  data () {
    return {
      obj: null,
      tabIndex: Tabs.SEARCH
    }
  },
  components: {
    Search,
    Board
  },
  methods: {
    onResetBoard () {
      this.$refs.Board.showHistory = false
      this.$refs.Board.dataHistory = null

      this.$refs.Board.hasNewEmployee = false
      this.$refs.Board.hasNewBoard = false
    },
    onEditEmployeeBoard (obj) {
      this.$refs.Board.onEditEmployeeBoard(obj)
      this.tabIndex = Tabs.BOARD_EMPLOYEE
    },
    onNewBoard () {
      this.$refs.Board.onAddBoard()
      this.tabIndex = Tabs.BOARD_EMPLOYEE
    },
    onDeleteBoard (obj) {
      EmployeeBoardRepository.Delete(obj.id)
        .then(response => {
          if (response.data.code > 0) {
            this.$refs.Board.onCreateHistory(obj, 'EXCLUIU O QUADRO')
            this.tabIndex = Tabs.SEARCH
            this.$refs.Search.onSearch()
            toast.success(this.$lang.Common.Alerts.Success)
          }
        })
        .catch(err => this.onException(err))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/finance/employeeboard/employeeboard.vue